function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFFFFF",
  width: 32,
  height: 32,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#4E4E4E",
  opacity: 0.3,
  x: 2,
  y: 2.068,
  width: 28,
  height: 28,
  rx: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 19.613c0 1.603-1.28 2.903-2.857 2.903-1.578 0-2.857-1.3-2.857-2.903 0-1.604 1.279-2.903 2.857-2.903.196 0 .387.02.572.058l-.001-5.285h-8v11.614c0 1.546-1.19 2.81-2.689 2.898L9.857 26C8.28 26 7 24.7 7 23.097c0-1.604 1.28-2.903 2.857-2.903.196 0 .387.02.572.058V8H23v11.613z",
  fill: "#4E4E4E"
}));

function SvgDaxMusicfileicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxMusicfileicon);
export default __webpack_public_path__ + "static/media/dax-musicfileicon.58391d84.svg";
export { ForwardRef as ReactComponent };